import React from "react"
import style from "./mega-menu.mod.scss"
import { MenuItem, Card } from "@components"
import { motion } from "framer-motion"
import { GatsbyImage } from "gatsby-plugin-image"
import Button from "./button"

const LearnDesktopMenu = ({ columns, isOpen, index, modifiers = [] }) => {
  const variants = {
    open: {
      opacity: 1,
      y: 0,
      transition: { staggerChildren: 0.07, delayChildren: 0.2 }
    },
    closed: {
      opacity: 0,
      y: 32,
      transition: { staggerChildren: 0.05, staggerDirection: -1 }
    }
  }

  // Temporary mapping of column indices to new headings
  const newHeadings = [
    "Information",
    "Spas and Pools",
    "Saunas",
    "Outdoor Lifestyle"
  ]

  return (
    <div
      className={[
        style["mega-menu"],
        style["mega-menu--learn"],
        `${isOpen ? style["mega-menu--open"] : style["mega-menu--closed"]}`,
        ...modifiers
      ].join(" ")}
      aria-labelledby={`menu-${index}-button`}
      id={`menu-${index}-button`}
    >
      <motion.div
        className={style["mega-menu__container"]}
        initial={"closed"}
        animate={isOpen ? "open" : "closed"}
        variants={variants}
      >
        <div className={style["mega-menu__learn_heading"]}>
          <h2>Learn Centre</h2>
          <Button short secondary white to={"/learn"}>
            View all info
          </Button>
        </div>
        <div className={style["mega-menu__wrapper"]}>
          {columns?.map((column, columnIndex) => {
            if (column.__typename === "DatoCmsMenuLearnColumn") {
              const {
                heading,
                collections,
                placeholderImage,
                linkPath
              } = column

              return (
                <div
                  className={[style[`mega-menu__column`]].join(" ")}
                  key={`mega-menu__column--${column.id}`}
                >
                  <div className={style["mega-menu__category-link"]}>
                    <Button unstyled to={linkPath || "/"}>
                      <h3 className={style["mega-menu__heading"]}>
                        {newHeadings[columnIndex] || heading}
                      </h3>
                      {placeholderImage && (
                        <GatsbyImage
                          image={placeholderImage.gatsbyImageData}
                          alt={placeholderImage.alt || ""}
                        />
                      )}
                    </Button>
                  </div>
                  <motion.ul
                    initial={"closed"}
                    animate={isOpen ? "open" : "closed"}
                    variants={variants}
                    className={style["mega-menu__list"]}
                  >
                    {collections?.map((item, itemIndex) => {
                      let safePath = "/"

                      if (item.isExternal) {
                        safePath = item.path
                      } else if (
                        item.parentCategory &&
                        item.parentCategory.length > 0
                      ) {
                        safePath = `/learn/${item.parentCategory[0].slug}/${item.slug}/`
                      } else if (item.slug) {
                        safePath = `/learn/${item.slug}/`
                      }

                      return (
                        <MenuItem
                          key={`menu-item-${itemIndex}`}
                          displayText={item.title}
                          link={{
                            path: safePath
                          }}
                          isExternal={item.isExternal}
                          vertical={true}
                          tabIndex={isOpen ? 0 : -1}
                          unstyled
                        />
                      )
                    })}
                  </motion.ul>
                </div>
              )
            }
            return null
          })}
        </div>
      </motion.div>
    </div>
  )
}

export default LearnDesktopMenu
